<div class="flex min-w-0 flex-col gap-0.5 leading-none">
    <div class="truncate text-[11px] font-medium leading-[1.05] text-slate-700">
        <a
            *ngIf="hasRuleLink; else plainRuleName"
            [routerLink]="['/access-rules', accessRuleId]"
            target="_blank"
            class="inline-flex max-w-full items-center gap-1 truncate text-violet-700 transition-colors hover:text-violet-900 hover:underline">
            <span class="truncate">{{ resolvedRuleName }}</span>
            <fa-icon [icon]="['fal', 'external-link-alt']" class="shrink-0 text-[9px] opacity-70"></fa-icon>
        </a>
        <ng-template #plainRuleName>
            {{ resolvedRuleName }}
        </ng-template>
    </div>
    <div class="flex flex-wrap items-center gap-1 mt-0.5">
        <span class="inline-flex items-center whitespace-nowrap rounded-full px-1.5 py-px text-[10px] font-medium leading-none ring-1 ring-inset"
            [ngClass]="permissionBadgeClass(permission)">
            {{ permission | globalEnumPipe:'permission' | translate }}
        </span>
        <span class="inline-flex items-center whitespace-nowrap rounded-full px-1.5 py-px text-[10px] font-medium leading-none ring-1 ring-inset"
            [ngClass]="alertBadgeClass(alert)">
            {{ alert | globalEnumPipe:'alert' | translate }}
        </span>
        <a *ngIf="hasDwellSessionLink"
            [routerLink]="['/reports/access-rule-dwell']"
            [queryParams]="{ dwellSessionId: accessRuleDwellSessionId }"
            target="_blank"
            title="{{ 'SystemAdmin.Common.AccessDecisionSummary.DwellDetail' | translate }}"
            class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-slate-50 text-slate-600 ring-1 ring-inset ring-slate-200 transition-colors hover:bg-sky-50 hover:text-sky-700 hover:ring-sky-200">
            <fa-icon [icon]="['fal', 'clock']" class="text-[9px] leading-none"></fa-icon>
        </a>
    </div>
</div>
